
import { Candidate } from "@/components/candidates/types";

export const prepareResumeData = (candidate: Candidate) => {
  // Extract education from candidate data
  // Safely handle undefined education field
  const education = candidate.education ? 
    candidate.education.map((edu: any) => ({
      institution: edu.institution || edu.school || '',
      degree: edu.degree || edu.qualification || '',
      dates: edu.dates || `${edu.startYear || ''}-${edu.endYear || 'Present'}`
    })) : 
    [];

  // Extract experience from candidate data
  const experience = candidate.experience ?
    candidate.experience.map((exp: any) => ({
      company: exp.company || exp.organization || '',
      title: exp.title || exp.position || '',
      dates: exp.dates || `${exp.startDate || ''}-${exp.endDate || 'Present'}`,
      description: exp.description || ''
    })) : 
    [];

  // Extract certifications if available
  const certifications = candidate.certifications || [];

  // Return structured resume data
  return {
    education,
    experience,
    certifications,
    contactInfo: {
      email: candidate.email || '',
      phone: candidate.phone || '',
      address: candidate.address || ''
    }
  };
};
